<template>
  <section class="ly_topbanner" v-if="shows" :style="{ backgroundColor: visibleBannerItem.bgColor2 }">
    <a href="javascript: void(0);" class="wrap" @click.prevent="goTo(visibleBannerItem)">
      <img :src="visibleBannerItem.bannerImg" :alt="visibleBannerItem.bannerName" />
    </a>
    <button type="button" class="btn_close" @click="close">
      <i class="ico24_close_w"></i>
      <span class="txt_hidden">닫기</span>
    </button>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { crmMainTopBannerClick } from '@/helpers/ad/crm/crm.js'

export default {
  name: 'topBanner',

  data() {
    return {
      closed: false,
    };
  },

  computed: {
    ...mapGetters('home', ['topBanners']),

    visibleBannerItem() {
      return this.topBanners?.[0];
    },

    shows() {
      if (this.$route.name !== 'Mhowsbizhome') return false;
      if (this.closed) return false;
      return Boolean(this.visibleBannerItem);
    },
  },

  methods: {
    close() {
      this.closed = true;
    },

    goTo(data) {
      const { exhUrlPath, bannerTypeCd, eventTypeCd, exhUrlTypeCd, eventSeq } = data;

      /** crm 메인 페이지 최상단 배너 클릭 */
      crmMainTopBannerClick(data.bannerName);

      if (bannerTypeCd === 'URL') {
        if (exhUrlTypeCd === 'IN') {
          document.location.href = exhUrlPath;
          return;
        }
        window.open(exhUrlPath, '_blank');
        return;
      }
      if (bannerTypeCd === 'EVENT') {
        if (eventTypeCd === 'SURVEY') {
          this.$router.push({ name: 'eventreport', query: { eventSeq } });
          return;
        }
        this.$router.push({ name: 'eventview', query: { eventSeq } });
      }
    },
  },
};
</script>

<style scoped>
.slide-enter-active {
  transition-duration: 0.3s;
}

.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 300px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
